import { render } from "./NotasCredito.vue?vue&type=template&id=5b89be31"
import script from "./NotasCredito.vue?vue&type=script&lang=js"
export * from "./NotasCredito.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__